import React from 'react'
import { WithStylesProps } from 'react-jss'
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from '@azure/msal-react'

import Button from '../Button'
import { msalInstance } from '../../msalClient'
import { loginRequest } from '../../config/msalConfig'
import getLabels from '../../utils/getLabels'

import styles from './AuthenticateUser.styles'

type AuthenticateUserType = {
  children: React.ReactNode
} & WithStylesProps<typeof styles>

const authenticateUser = (props: AuthenticateUserType) => {
  const handleLogin = () => msalInstance.loginRedirect(loginRequest())

  return (
    <>
      <AuthenticatedTemplate>{props.children}</AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <div className={props.classes.login}>
          <div className={props.classes.transaviaLogo} />
          <p>{getLabels('login_message')}</p>
          <Button
            type="button"
            color="red"
            data-element="confirm-login"
            onClick={handleLogin}
          >
            {getLabels('login_btn')}
          </Button>
        </div>
      </UnauthenticatedTemplate>
    </>
  )
}

export default authenticateUser
